import React from 'react'
import { TPost } from '../../../../../types/Post';
import s from './PostMedia.module.scss'

function PostMedia({ post, cdnRoot }: { post: TPost, cdnRoot: string }): React.ReactElement {
    function getMediaFullUrl<K extends keyof TPost>(
        key: K,
        value: TPost[K]
    ) {
        post[key] = value;
    }

    const propertiesToCheckCdn: Array<keyof TPost> = ['thumbnail', 'videoUrl', 'videoUrlInternal', 'img']
    propertiesToCheckCdn.forEach((key) => {
        const linkValue = post[key];
        // eslint-disable-line no-useless-concat
        const startsWithHttps = new RegExp(`^https://`, 'i');
        if (!linkValue || startsWithHttps.test(linkValue)) {
            return;
        }
        const newValue = `${cdnRoot}${linkValue.charAt(0) === '/' ? linkValue : `/${linkValue}`}`
        getMediaFullUrl(key, newValue);
    })
    return (
        <div style={{ marginLeft: '-2px', marginRight: '-2px', marginTop: 'auto' }}>
            <img
                src={post.img || post.thumbnail}
                className={s.postThumbnail}
                alt='post'
                style={{ height: '325px' }}
            />
        </div>
    )
}

export default PostMedia